﻿define(
//begin v1.x content
({
	invalidMessage: "Įvesta reikšmė netinkama.",
	missingMessage: "Ši reikšmė privaloma.",
	rangeMessage: "Ši reikšmė nepatenka į intervalą."
})
//end v1.x content
);
